import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COMPRESSED_IMAGE_URL } from '../../config/config';
import { RiArrowDropRightLine, RiCloseLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import EmptyCart from '../images/empty_cart.png';
import { useDispatch } from 'react-redux';
import { deleteCartData, getCartData } from '../../Redux/features/auth/authSlice';
import { MdImageNotSupported } from 'react-icons/md';

const ShoppingCart = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [ProductData, setProductData] = useState([]);
	const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
	const dispatch = useDispatch();
	const [hasFetched, setHasFetched] = useState(false);

	const handleOpenModal = (product) => {
		setSelectedProduct(product);
		setModalOpen(true);
	};

	// Function to close modal
	const handleCloseModal = () => {
		setModalOpen(false);
		setSelectedProduct(null);
	};

	useEffect(() => {
		const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
		if (cartData.length === 0 || hasFetched) return;

		setProductData(cartData);
		setHasFetched(true);
	}, [hasFetched]);

	const navigate = useNavigate();

	// Update subtotal to use ProductData and include updated quantities
	const subtotal = ProductData.reduce((acc, product) => {
		return acc + product.DiscountMRP * product.Qty;
	}, 0).toFixed(2);

	const overallTotal = ProductData.reduce((total, product) => {
		const totalPrice =
			product.OrderDetails?.reduce((sum, item) => sum + (item.Qty * item.DiscountMRP || 0), 0) || 0;

		return total + totalPrice;
	}, 0);

	const overallQty = ProductData.reduce((total, product) => {
		const totalQty = product.OrderDetails?.reduce((sum, item) => sum + item.Qty, 0) || 0;

		return total + totalQty;
	}, 0);

	// Navigate to order detail page with cartData and subtotal
	const handleCheckout = () => {
		navigate('/orderdetail', {
			state: { cartData, subtotal },
		});
	};

	// Remove item from cartData and ProductData
	const removeFromCart = (index) => {
		const ArticleId = ProductData[index].ArticleCode;
		// Remove item from ProductData
		const updatedProductData = ProductData.filter((_, i) => i !== index);
		setProductData(updatedProductData);

		// Remove item from cartData and update localStorage
		dispatch(deleteCartData(ArticleId)).then((data) => {
			if (data.type === '/deleteCartData/fulfilled') {
				dispatch(getCartData());
			}
		});
	};

	return (
		<>
			<Link
				to='/dashboard'
				className='flex justify-between items-center md:px-10 px-5 py-4 bg-red-400 text-white uppercase font-bold hover:bg-[#231942] transition-colors duration-300 mt-5'>
				<p className='text-lg max-[300px]:text-sm'>Shopping Cart</p>
				<RiArrowDropRightLine className='md:text-4xl text-2xl max-[300px]:text-lg' />
			</Link>
			<div className='md:px-5 px-2  md:mx-12 mx-5 max-[300px]:mx-0 '>
				{ProductData.length === 0 ? (
					<div className='flex flex-col justify-center items-center'>
						<img
							src={EmptyCart}
							alt='Empty Cart'
							className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
						/>

						<Link to={'/dashboard'} className=' proBtn'>
							Return to Shop
						</Link>
					</div>
				) : (
					<>
						{ProductData.map((product, index) => {
							const totalQty = product.OrderDetails?.reduce((sum, item) => sum + item.Qty, 0) || 0;
							const totalPrice =
								product.OrderDetails?.reduce((sum, item) => sum + item.Qty * item.DiscountMRP, 0) ||
								0;

							return (
								<div key={index} className='flex  justify-between border-b mb-4'>
									<div className='flex py-2 '>
										{product?.ParentImage ? (
											<img
												src={`${COMPRESSED_IMAGE_URL}/${product.ParentImage}`}
												alt={product.ProductName}
												className='w-24 h-32 object-cover max-[300px]:w-20 max-[300px]:h-28 max-[300px]:mr-2 mr-5'
											/>
										) : (
											<div className='w-24 h-32 flex flex-col justify-center items-center text-red-500 opacity-75 bg-black bg-opacity-10 max-[300px]:w-20 max-[300px]:h-28 max-[300px]:mr-2 mr-5'>
												<MdImageNotSupported className='text-3xl' />
												<p className='text-[10px] font-medium text-center'>No Image Available</p>
											</div>
										)}
										<div className='flex flex-col justify-start ml-10'>
											<p className='font-semibold my-2'>
												{product.ProductName?.length > 30
													? product.ProductName.slice(0, 30) + '...'
													: product?.ProductName}
											</p>
											<button
												onClick={() => handleOpenModal(product)}
												className=' w-36 bg-red-400 text-white rounded font-semibold py-1.5 hover:bg-red-500  transition-colors duration-300'>
												Order Details
											</button>

											<p className='text-sm font-medium text-gray-600 mt-2 '>
												Total Qty: {totalQty}
											</p>
											<p className='text-sm font-semibold'>
												Total Price: <span className='font-sans'>₹</span>{' '}
												{totalPrice.toLocaleString('en-IN', {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												})}
											</p>
										</div>
									</div>

									<button
										onClick={() => removeFromCart(index)}
										className='text-red-500 hover:text-red-700'>
										<RiCloseLine className='text-xl md:mr-7 mr-3 max-[300px]:mr-2' />
									</button>
								</div>
							);
						})}

						{modalOpen && selectedProduct && (
							<div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center'>
								<div className='bg-white p-5 rounded-lg  shadow-lg'>
									<h2 className='text-lg font-semibold mb-3 text-center '>
										{selectedProduct.ProductName}
									</h2>

									<div className='max-h-[440px] border border-gray-300 rounded-md overflow-y-auto custom-scrollbar'>
										<table className='min-w-full border-collapse table-auto text-black'>
											<thead className=' bg-white top-0  '>
												<tr className='text-sm font-medium '>
													{/* <th className='border px-2 py-2 text-center'>ID</th> */}

													<th className='border px-2 py-2 text-center'>Color</th>
													<th className='border px-5 py-2 text-center'>Size</th>
													<th className='border px-2 py-2 text-center'>Quantity</th>
													<th className='border px-2 py-2 text-center'>MRP</th>
													<th className='border px-2 py-2 text-center'>Discount</th>
													<th className='border px-2 py-2 text-center'>DiscountMRP</th>
													<th className='border px-4 py-2 text-center'>Subtotal</th>
												</tr>
											</thead>

											<tbody>
												{selectedProduct.OrderDetails?.map((orderDetail, index) => {
													return (
														<tr key={index} className='text-sm'>
															{/* <td className='border px-3 py-2 text-center'>{orderDetail.Id}</td> */}
															<td className=' border px-3 py-2 text-center'>{orderDetail.color}</td>
															<td className=' border px-3 py-2 text-center'>{orderDetail.size}</td>
															<td className='border px-3 py-2 text-center'>{orderDetail.Qty}</td>
															<td className='border px-3 py-2 text-center'>
																<span className='font-serif text-[16.5px] font-normal'>₹</span>
																{orderDetail.MRP}
															</td>
															<td className='border px-3 py-2 text-center'>
																{orderDetail.DiscountType === 'R' ? (
																	<>
																		<span className='font-serif'>₹</span>
																		{orderDetail.Discount}
																	</>
																) : orderDetail.DiscountType === 'P' ? (
																	<>
																		{orderDetail.Discount}
																		<span>%</span>
																	</>
																) : (
																	orderDetail.Discount
																)}
															</td>
															<td className='border px-3 py-2 text-center '>
																<span className='font-serif text-[16.5px] font-normal'>₹</span>
																{orderDetail.DiscountMRP}
															</td>
															<td className='border px-3 py-2 text-center'>
																<span className='font-serif text-[16.5px] font-normal'>₹</span>
																{(orderDetail.Qty * orderDetail.DiscountMRP).toLocaleString(
																	'en-IN',
																	{
																		minimumFractionDigits: 2,
																		maximumFractionDigits: 2,
																	}
																)}
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>

									{/* Overall total price for the selected product */}
									<div className=' mt-2 flex flex-row justify-between pl-3 pr-4 font-normal text-base'>
										<div>Total Quantity :</div>
										<div>
											{selectedProduct.OrderDetails?.reduce((sum, item) => sum + item.Qty, 0)}
										</div>
									</div>
									<div className='  flex flex-row justify-between pl-3 pr-4 font-medium text-base'>
										<div>Total Price :</div>

										<div>
											<span className='font-sans text-xl'> ₹ </span>
											{selectedProduct?.OrderDetails?.reduce(
												(sum, item) => sum + item.Qty * item.DiscountMRP,
												0
											).toLocaleString('en-IN', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</div>
									</div>

									{/* Close button */}
									<button
										onClick={handleCloseModal}
										className='mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600'>
										Close
									</button>
								</div>
							</div>
						)}

						<div className=' flex justify-center  items-center flex-col space-y-3 mb-10'>
							<div className=' flex-col justify-center items-center gap-1 flex'>
								<p className='max-[300px]:text-sm font-semibold '>Total Qty: {overallQty}</p>
								<p className=' max-[300px]:text-sm font-semibold '>
									Subtotal: <span className='font-sans text-lg'>₹ </span>
									{overallTotal.toLocaleString('en-IN', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</p>
							</div>
							<div className='flex justify-center items-center'>
								<button
									onClick={handleCheckout}
									className=' rounded-none bg-[#231942] md:px-32 py-4 px-28 max-[300px]:px-16 lg:text-sm text-xs font-semibold text-white hover:bg-[#ff6565] transition-colors duration-300 uppercase mb-3'>
									Checkout
								</button>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	);
};

export default ShoppingCart;
